import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Data for all the claim tabs
const claimsData = {
  'Hull-Machinery': {
    title: 'Hull & Machinery Claims (H&M)',
    types: [`<b>Collision & Allision Damage</b> <br/> Impact with another vessel or fixed object.`, `<b>Grounding / Stranding Damagen</b> <br/> Bottom contact causing hull, propeller, or machinery damage.`, `<b>Machinery Breakdown</b> <br/> Engine, generator, pump, or system failures due to mechanical or electrical faults.`, `<b>Fire & Explosion</b> <br/> Structural, machinery, or equipment damage caused by onboard ignition sources.`, `<b>Heavy Weather Damage</b> <br/> Structural stress, hull deformation, equipment loss, or water ingress during severe conditions.`, `<b>Ice Damage</b> <br/> Hull or propeller damage from navigating ice-affected waters.`, `<b>Contact Damage in Port</b> <br/> Damage during berthing, unberthing, cargo operations, or tug interactions.`, `<b>Salvage, Towage & Emergency Costs</b> <br/> Expenses incurred to protect the vessel following an insured peril.`, `<b>Latent Defect-Related Damage</b> <br/> Failures arising from hidden flaws in machinery or components.`],
    docs: ['**Master’s Incident Report detailing the circumstances of the damag**', '**Deck & Engine Logbook extracts covering the event period**', '**Photographs and video evidence of the damage**', '**Surveyor’s preliminary and final reports**', '**VDR / AIS data where relevant**', '**Repair specifications and quotations from shipyards or contractors**', '**Final repair invoices and supporting cost breakdowns**', '**Class records and recommendations related to the incident**', '**Maintenance and service history of affected machinery or systems**', '**Correspondence with authorities, third parties, and insurers**', '**Notice of Protest (if applicable)**', '**Towage, salvage, or emergency service documents**', '**Crew statements or witness accounts**'],
    toolsDesc: 'Use the link below to access our integrated system for real-time updates and document submission.',
    // statusLink: './claims.html#status-lookup',
    // newClaimLink: './claims.html',
    statusText: 'Check H&M Claim Status',
    newClaimText: 'Start a New H&M Claim',
  },
  // Cargo: {
  //   title: 'Cargo Damage Claims',
  //   types: ['Physical Damage (Wet/Impact)', '**Subrogation & Recovery**', 'Contamination (Liquid/Bulk)', 'Cargo Condensation & Sweat'],
  //   docs: ['**Bill of Lading (B/L) copy**', 'Cargo Manifest / Packing List', 'Insurance Policy/Certificate', 'Survey Report (if available)'],
  //   toolsDesc: 'We specialize in subrogation and recovery management for high-value cargo losses.',
  //   // statusLink: './claims.html#status-lookup',
  //   // newClaimLink: './claims.html',
  //   statusText: 'Check Cargo Claim Status',
  //   newClaimText: 'Start a New Cargo Claim',
  // },
  Liability: {
    title: 'Strategic Assessments, Audits and Vessel Inspections',
    types: ['Third-Party Collision Liability', 'Pollution Fines and Costs', 'Wreck Removal Costs', 'Crew Illness / Injury (Repatriation)'],
    docs: ['**Detailed Incident Report**', 'Crew Lists / Medical Reports', 'P&I Letter of Undertaking (LOU)', 'Expert/Legal Opinion (if applicable)'],
    toolsDesc: 'We act as impartial adjusters to assist in the complex financial apportionment of P&I liabilities.',
    // statusLink: './claims.html#status-lookup',
    // newClaimLink: './claims.html',
    statusText: 'Check P&I Claim Status',
    newClaimText: 'Start a New Liability Claim',
  },
  'General-Average': {
    title: 'General Average',
    types: [`<b>Sacrificial Damage</b> <br/> Deliberate damage to ship or cargo (e.g., jettison, flooding a hold) to preserve the common adventure.`, `<b>Firefighting Measures</b> <br/> Costs of extinguishing a fire onboard, including water damage caused by firefighting efforts.`, `<b>Refloating & Salvage Operations</b> <br/> Expenses incurred to refloat a grounded vessel or engage salvors to prevent total loss.`, `<b>Port of Refuge (PoR) Expenses</b> <br/> Costs of deviation to a safe port, including port charges, surveys, temporary repairs, and additional bunkers consumed.`, `<b>Temporary Repairs</b> <br/> Repairs necessary to enable the vessel to safely continue the voyage after a GA event.`, `<b>Cargo Handling & Storage Costs</b> <br/> Discharge, reloading, storage, and transshipment expenses at a port of refuge.`, `<b>Tug Assistance</b> <br/> Towage or tug services used to avert a peril threatening the common adventure.`, `<b>Crew Wages & Maintenance During Delay</b> <br/> Wages, provisions, and maintenance while the vessel is detained at a port of refuge for GA-related operations.`, `<b>General Average Security & Documentation Costs</b> <br/> Fees and administrative expenses related to collecting GA bonds, guarantees, and adjusting the claim.`],
    docs: ['**Master’s GA Statement / Incident Report outlining the circumstances leading to the GA act**', '**Logbook extracts (Deck & Engine) covering the event and subsequent actions**', '**Notice of General Average issued by the shipowner**', '**Survey reports detailing damage, cause, and necessary repairs**', '**Firefighting, salvage, or refloating reports (if applicable)**', '**Port of Refuge (PoR) documentation including port charges, bunkers consumed, and deviation details**', '**Temporary repair invoices and supporting cost breakdowns**', '**Cargo manifests and stowage plans**', '**Bills of Lading for all cargo interests**', '**Cargo discharge, handling, storage, and reloading invoices**', '**General Average Bonds and Guarantees from cargo interests and insurers**', '**Crew wages and maintenance records during PoR detention**', '**Towage, salvage, and tug assistance invoices**', '**Correspondence with salvors, authorities, cargo interests, and insurers**', '**Class recommendations and technical reports related to the GA event**'],
    toolsDesc: 'As expert Average Adjusters, we handle the entire process from declaration to final adjustment and collection.',
    // statusLink: './ClaimsPage#status-lookup',
    // newClaimLink: './ClaimsPage',
    statusText: 'Check GA Status',
    newClaimText: 'Report a GA Incident',
  },
};

function ClaimsCenter() {
  const [activeTab, setActiveTab] = useState('Hull-Machinery');
  const currentClaim = claimsData[activeTab];

  const handleTabClick = (claimName) => {
    setActiveTab(claimName);
  };

  const renderList = (items) => (
    <ul className="list-disc list-inside" style={{ listStyleType: 'disc', paddingLeft: '0.5rem', marginTop: '0.5rem', marginBottom: '0.5rem', fontSize: '0.875rem', color: '#475569', lineHeight: '1.5' }}>
      {items.map((item, index) => (
        <li key={index} dangerouslySetInnerHTML={{ __html: item.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }}></li>
      ))}
    </ul>
  );

  return (
    <section id="claims-center" className="bg-light-gray" style={{marginLeft: '3rem', marginRight: '3rem'}}>
      <div className="max-w-[80rem] mx-auto px-6">
        <h2 style={{ fontSize: '1.875rem', fontWeight: '700', textAlign: 'center', marginBottom: '1rem' }}>
          Comprehensive Claims Center
        </h2>
        <p style={{ fontSize: '1.125rem', color: '#475569', textAlign: 'center', maxWidth: '48rem', margin: 'auto', marginBottom: '2.5rem' }}>
          Your central hub for initiating claims, understanding required
          documents, and checking the status of your adjustment.
        </p>

        <div className="tab-buttons-container">
          {Object.keys(claimsData).map((key) => (
            <button
              key={key}
              className={`tab-button ${activeTab === key ? 'active' : ''}`}
              onClick={() => handleTabClick(key)}
            >
              {claimsData[key].title.split('(')[0].trim()}
            </button>
          ))}
        </div>

        <div className="tab-content-container">
          <div id={activeTab} className="tab-content active">
            <h3 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem' }}>
              {currentClaim.title}
            </h3>
            <div className="grid-cols-1-md-3">
              <div>
                <h4 style={{ fontWeight: '700', fontSize: '1.125rem', marginBottom: '0.5rem', color: 'var(--brand-gold)' }}>
                  Covered Claim Types
                </h4>
                {renderList(currentClaim.types)}
              </div>
              <div>
                <h4 style={{ fontWeight: '700', fontSize: '1.125rem', marginBottom: '0.5rem', color: 'var(--brand-gold)' }}>
                  Required Documents
                </h4>
                {renderList(currentClaim.docs)}
              </div>
              <div>
                <h4 style={{ fontWeight: '700', fontSize: '1.125rem', marginBottom: '0.5rem', color: 'var(--brand-gold)' }}>
                  Claims Management Tools
                </h4>
                <p style={{ fontSize: '0.875rem', marginBottom: '1rem' }}>
                  {currentClaim.toolsDesc}
                </p>
                <Link to="./claims#status-lookup"  className="btn-secondary" style={{ fontSize: '0.875rem', padding: '0.5rem 0.75rem', marginBottom: '0.5rem' }}>
                  {currentClaim.statusText}
                </Link>
                <a href="./claims" className="btn-primary" style={{ fontSize: '0.875rem', padding: '0.5rem 0.75rem' }}>
                  {currentClaim.newClaimText}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ClaimsCenter;